export const useGetCountry = () => {
  const countryCode = localStorage.getItem('userCountryCode')
  const isFromPakistan = countryCode === 'PK'
  return { countryCode, isFromPakistan }
}